import { useState, useEffect } from 'react';

interface AppVersionData {
  version: string;
  changelogs: Array<{
    version: string;
    changelog: string;
    releasedAt: string;
  }>;
}

export function useAppVersion() {
  const [versionData, setVersionData] = useState<AppVersionData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await fetch('/api/app-version');
        if (!response.ok) {
          throw new Error('Errore caricamento versione');
        }
        const data = await response.json();
        setVersionData(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Errore sconosciuto');
        // Fallback alla versione di default
        setVersionData({
          version: 'V 0.9',
          changelogs: []
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchVersion();
  }, []);

  return {
    version: versionData?.version || 'V 0.9',
    changelogs: versionData?.changelogs || [],
    isLoading,
    error
  };
}
